import React from 'react';
import { ReactComponent as ZLogoNoText } from 'assets/svg/logo-noText-black.svg';
import AppPrivataIcon from 'Containers/Common/AppPrivataIcon';

const AppPrivataSidebarIcon = () => {
  const size = 26;

  return (
    <div
      style={{
        position: 'relative',
        width: `${size}px`,
        height: `${size}px`,
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '80%',
          height: '80%',
          borderRadius: '6px',
          border: '1px solid #1f1f1f',
          boxShadow: '0 2px 6px rgba(15, 23, 42, 0.18)',
        }}
      />
      <div
        style={{
          position: 'absolute',
          bottom: -1,
          right: -3,
          width: '90%',
          height: '90%',
          borderRadius: '8px',
          background: '#1f1f1f',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: '2px solid #DFE0FF',
          boxShadow: '2px 3px 6px rgba(15, 23, 42, 0.18)',
        }}
      >
        <AppPrivataIcon size={18} />
      </div>
    </div>
  );
};

export default AppPrivataSidebarIcon;

